import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import countriesListSaga from './sagas/countriesListSaga';

export default [
  // Lists
  ...createCombineMapItem('countriesList', createListReduceObject, [
    countriesListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/reducers/static/lists/reducersMap.js